// extracted by mini-css-extract-plugin
export default {"categoryDetails":"SubjectListItem_categoryDetails__lWvfL","categoryImage":"SubjectListItem_categoryImage__ugn6j","categoryItem":"SubjectListItem_categoryItem__4g1uw"};